// extracted by mini-css-extract-plugin
export default {"textHeading":"services_textHeading__vQu+P","servText":"services_servText__r7UPv","mainDiv":"services_mainDiv__5dk6R"};